import React, { useContext, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import './Header.css'
import { BiSearch } from 'react-icons/bi'
import { AiOutlineUser } from 'react-icons/ai'
import { LuShoppingCart } from 'react-icons/lu'
import Logo from '../../Assets/images/logo/SenicLogo.png'
import NavbarComponent from '../../Components/NavbarComponent/NavbarComponent'
import NavbarResponsive from '../../Components/NavbarResponsive/NavbarResponsive'
import { Link, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { isLoggedIn } from '../../Hooks/isLoggedIn'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import { toast } from 'react-toastify'
import { CartContext } from '../../Hooks/CartContext'

export default function Header() {
    let searchValue = "";
    const [ShowCart, setShowCart] = useState(false)
    const { cartItems, addToCart } = useContext(CartContext);
    const handleShowCart = () => {
        setShowCart(!ShowCart)
    }
    const Navigate = useNavigate()
    
    const handleSearch = () => {
        if (searchValue == '')
            return toast.warn('متن جست و جو نمیتواند خالی باشد')
        Navigate('/search/' + searchValue + '/all')

    }

    useEffect(() => {
        if (isLoggedIn())
            axiosConfig.get("api/shoppingCart").then((res) => {
                let count = 0;
                debugger;
                res.data.items.map(item => {
                    return count += item.quantity;
                })
                addToCart(count);
            }).catch((res) => {

            });
    }, []);

    return (
        <>
            <Container fluid='lg' className='header-container'>
                <div className='header-right'>
                    <Link to='/'>
                        <img src={Logo} alt="لوگو سه نیک" />
                    </Link>
                    <div className='header-search-box'>
                        <input type="text" placeholder='جستجوی دوره و محصولات و ...' onChange={(e) => {
                            searchValue = e.target.value
                        }} />
                        <div className='search-icon' onClick={handleSearch}  >
                            <BiSearch />
                        </div>
                    </div>
                </div>
                <div className='header-left'>
                    <Link to='/cart'>
                        <div className='cart-icon' onMouseEnter={handleShowCart}>
                            <LuShoppingCart />
                            <span className='cart-notif'>{cartItems}</span>
                        </div>
                    </Link>

                    <div className='login-icon'>
                        <button >
                            {
                                isLoggedIn() == true ? (
                                    <Link to='/userpanel'>
                                        <AiOutlineUser />
                                        پنل کاربری
                                    </Link>
                                ) : (
                                    <Link to='/Login'>
                                        <AiOutlineUser />
                                        ورود و عضویت
                                    </Link>
                                )
                            }

                        </button>
                    </div>
                </div>
            </Container>
            <NavbarComponent />
            <NavbarResponsive />
        </>

    )
}
